import React from 'react';
import { Form } from 'react-bootstrap';
import { MONACO_LANG, LANGUAGE_VERSIONS } from '../constants/languages';

const LanguageSelect = ({ onLanguageChange, selectedLanguage }) => {
    return (
        <Form.Select
            aria-label="Select Language"
            onChange={(e) => onLanguageChange(e.target.value)}
            value={selectedLanguage}
            className="w-auto border-secondary"
            style={{ maxWidth: '200px' }}
        >
            {Object.entries(MONACO_LANG).map(([id, name]) => (
                <option key={id} value={name}>
                    {name.toUpperCase()} ({LANGUAGE_VERSIONS[name] || "Latest"})
                </option>
            ))}
        </Form.Select>
    );
};

export default LanguageSelect;
